// Grid code version status pill: in force in the ok tone, draft, published, superseded and archived in grey, always with the word.
import { CircleCheckIcon, CircleDashedIcon, HistoryIcon } from "lucide-react";

import type { DocumentStatus } from "@/api/__generated__";
import { Badge } from "@/components/ui/badge";
import { DOCUMENT_STATUS_LABELS } from "@/lib/labels";

export function DocumentStatusBadge({ status, className }: { status: DocumentStatus; className?: string }) {
  if (status === "in_force") {
    return (
      <Badge variant="ok" className={className}>
        <CircleCheckIcon aria-hidden />
        {DOCUMENT_STATUS_LABELS[status]}
      </Badge>
    );
  }
  const Icon = status === "superseded" || status === "archived" ? HistoryIcon : CircleDashedIcon;
  return (
    <Badge variant="grey" className={className}>
      <Icon aria-hidden />
      {DOCUMENT_STATUS_LABELS[status]}
    </Badge>
  );
}
